export const normalizeData = ({ data = [], enums = {} }) => {
  return data.map((item) => ({
    ...item,
    rowData: item,
    fuelType:
      enums.fuelTypes?.find((fuel) => fuel.value === item.fuelType)?.text ||
      '-',
    transmission:
      enums.transmissions?.find((trans) => trans.value === item.transmission)
        ?.text || '-',
    title: [item.brand, item.model, item.edition].join(' '),
    price: item.price?.number || '-',
  }));
};

export const handleEnums = (data = {}) => {
  const fuelTypes =
    data?.fuelTypes?.map((item) => ({
      text: item.name,
      value: item.id,
    })) ?? [];

  const transmissions =
    data?.transmissions?.map((item) => ({
      text: item.name,
      value: item.id,
    })) ?? [];

  const colors = Object.keys(data?.colors ?? {}).map((key) => ({
    text: data.colors[key].name,
    value: data.colors[key].name,
  }));

  const brands = Object.keys(data?.models ?? {}).map((key) => ({
    value: data.models[key].name,
    text: data.models[key].name,
    models: Object.keys(data.models[key].models).map((modelKey) => ({
      value: data.models[key].models[modelKey].name,
      text: `${data.models[key].models[modelKey].name} (${data.models[key].name})`,
    })),
  }));

  return {
    fuelTypes,
    brands,
    transmissions,
    colors,
  };
};
